var _rect, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFadersBold(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Raw",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256.00098 256.00098",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "none"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 128.00098,
    y1: 120,
    x2: 128.0011,
    y2: 216,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 128.0011,
    y1: 40,
    x2: 128.00098,
    y2: 88,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 200.00098,
    y1: 200,
    x2: 200.00181,
    y2: 216,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 200.00181,
    y1: 40,
    x2: 200.00098,
    y2: 168,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 224.00098,
    y1: 168,
    x2: 176.00098,
    y2: 168,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 56.00098,
    y1: 168,
    x2: 56.00039,
    y2: 216,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 56.00039,
    y1: 40,
    x2: 56.00098,
    y2: 136,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 32.00098,
    y1: 136,
    x2: 80.00098,
    y2: 136,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 152.00098,
    y1: 88,
    x2: 104.00098,
    y2: 88,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 24
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFadersBold);
export default __webpack_public_path__ + "static/media/faders-bold.29de2ba0.svg";
export { ForwardRef as ReactComponent };